import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Notification} from '../models/notification/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications: Notification[] = [];
  subject = new BehaviorSubject<Notification[]>(null);
  items$ = this.subject.asObservable();

  constructor() {
    this.init();
  }

  public init() {
    this.notifications.splice(0, this.notifications.length);
  }

  public addNotification(notification: Notification) {
    if (!this.notifications.find(n => (n.text === notification.text && n.category === notification.category))) {
      this.notifications.push(notification);
    }
    this.subject.next(this.notifications);
    if (notification.duration) {
      setTimeout(() => {
        this.notifications = this.notifications.filter(v => v !== notification);
        this.subject.next(this.notifications);
      }, notification.duration);
    }
  }

  public removeNotification(index: number) {
    this.notifications = this.notifications.filter((notification, i) => i !== index);
    this.subject.next(this.notifications);
  }
}
